import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import { default as MuiCheckbox } from "@material-ui/core/Checkbox";
import CircleUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const Checkbox = (props) => {
	const { name, label, value, checked, handleChange, color } = props;
	const ColorCheckbox = withStyles({
		root: {
			color: color || "#333399",
			"&$checked": {
				color: color || "333399",
			},
		},
		checked: {},
	})((props) => <MuiCheckbox color="default" {...props} />);

	return (
		<FormControlLabel
			control={
				<ColorCheckbox
					id={`${name}_${value}_checkbox`}
					checked={checked}
					onChange={(event) => {
						if (handleChange) {
							handleChange({ key: event.target.name, value: value });
						}
					}}
					icon={<CircleUncheckedIcon />}
					checkedIcon={<CheckCircleIcon />}
					name={name}
				/>
			}
			label={<div style={{ fontSize: 13, whiteSpace: "nowrap" }}>{label}</div>}
		/>
	);
};

Checkbox.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	checked: PropTypes.bool,
	handleChange: PropTypes.func,
	color: PropTypes.string,
};
Checkbox.defaultPorps = {
	color: "#333399",
};
